import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPackagesMain } from './modules/ui/Main';

const PackagesPage = (
  <SuspensePage>
    <PagesPackagesMain />
  </SuspensePage>
);

export default PackagesPage;
